import { Component, Input, OnInit } from '@angular/core';
import { Cliente } from 'src/app/model/cliente.model';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-login-code',
  templateUrl: './login-code.component.html',
  styleUrls: ['./login-code.component.scss'],
})
export class LoginCodeComponent implements OnInit {


  @Input() localeId: string;
  @Input() windowRef;
  @Input() cliente: Cliente;

  errorMessage = '';
  code = '';

  constructor(
    private _utilsService: UtilsService,
  ) { }

  ngOnInit() { }

  get path() {
    return `assets/${this.localeId}/logo_black.png`;
  }

  test() {
    console.log(this.code);
  }

  verifyLoginCode() {
    this._utilsService.dismiss(this.code);
  }

  dismiss() {
    this._utilsService.dismiss(null);
  }
}
